import React, { useEffect, useState } from 'react';
import api from '../../api';
import './SUPJeopardyReport.css';
import '../Buttons.css'

const SUPJeopardyReport = ({ currentSupplier }) => {
    const [items, setItems] = useState([]); 
    const [selectedStatus, setSelectedStatus] = useState(null); 
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('');

    // ------------------------------------------------------------
    // Load ALL items with jeopardy status
    // ------------------------------------------------------------
    useEffect(() => {
        const fetchItems = async () => {
            try {
                setLoading(true);
                const res = await api.get(`/supplierReport/orderStatus/${currentSupplier.id}`);
                setItems(res.data || []);
                setStatus('');
            } catch (err) {
                console.error('Error fetching jeopardy report:', err);
                setStatus('Error loading jeopardy report.');
            } finally {
                setLoading(false);
            }
        };

        fetchItems();
    }, [currentSupplier.id]);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return dateString.split('T')[0];   // works for ISO strings
    };

    // Group items by status
    const redItems = items.filter(i => i.status === 'RED');
    const yellowItems = items.filter(i => i.status === 'YELLOW');
    const greenItems = items.filter(i => i.status === 'GREEN');

    return (
        <div className="supplier-jeopardy-report">
            <h3>Order Jeopardy Report</h3>

            {loading && <p>Loading�</p>}
            {status && <p className="status-message">{status}</p>}

            {/* ------------------------------------------------------------
                MASTER LIST VIEW
            ------------------------------------------------------------ */}
            {!loading && !selectedStatus && (
                <table className="matrix-grid">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Count</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr onClick={() => setSelectedStatus('RED')} style={{ cursor: 'pointer' }}>
                            <td style={{ color: 'red' }}>RED</td>
                            <td>{redItems.length}</td>
                        </tr>

                        <tr onClick={() => setSelectedStatus('YELLOW')} style={{ cursor: 'pointer' }}>
                            <td style={{ color: 'goldenrod' }}>YELLOW</td>
                            <td>{yellowItems.length}</td>
                        </tr>

                        <tr onClick={() => setSelectedStatus('GREEN')} style={{ cursor: 'pointer' }}>
                            <td style={{ color: 'green' }}>GREEN</td>
                            <td>{greenItems.length}</td>
                        </tr>
                    </tbody>
                </table>
            )}

            {/* ------------------------------------------------------------
                DETAIL VIEW
            ------------------------------------------------------------ */}
            {!loading && selectedStatus && (
                <>
                    <button className="button" onClick={() => setSelectedStatus(null)}>
                        Back to Summary
                    </button>

                    <h4>{selectedStatus} Items</h4>

                    <table className="matrix-grid">
                        <thead>
                            <tr>
                                <th>Crop</th>
                                <th>Variety</th>
                                <th>Units</th>
                                <th>Paid Date</th>
                                <th>Days Since</th>
                                <th>Days Remaining</th>
                            </tr>
                        </thead>

                        <tbody>
                            {items
                                .filter(i => i.status === selectedStatus)
                                .map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.crop}</td>
                                        <td>{row.supplierVariety}</td>
                                        <td>{row.totalPackets}</td>
                                        <td>{formatDate(row.paidDate)}</td>
                                        <td>{row.daysSinceOrdered}</td>
                                        <td>{row.daysRemaining}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
};

export default SUPJeopardyReport;
